import { motion } from "framer-motion";
import StepBoxes from "./StepBoxes";

const HeroSection = () => {
  return (
    <>
      <section
        className="relative h-[300px] md:h-[600px] flex items-center justify-center bg-cover bg-center bg-no-repeat border-b-[3px] border-brandGreen overflow-hidden"
        style={{ backgroundImage: "url('/images/banner.png')" }}
        id="hero"
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-brandDark opacity-60 z-0"></div>

        {/* Animowana TREŚĆ (od lewej) */}
        <motion.div
          initial={{ opacity: 0, x: -60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1.2, ease: [0.25, 1, 0.5, 1] }}
          viewport={{ once: true, amount: 0.6 }}
          className="relative z-10 text-center px-4 p-6 rounded-lg"
        >
          <h2 className="text-3xl md:text-5xl font-bold mb-4 text-brandLight">
            Zacznij swoją przemianę!
          </h2>
          <p className="text-lg text-brandLight mb-6">Zaufaj doświadczeniu i pasji.</p>
          <a
            href="#contact"
            className="bg-brandGreen text-white px-6 py-3 rounded-lg hover:bg-brandGreenDark transition"
          >
            Skontaktuj się
          </a>
        </motion.div>
      </section>

      <div className="hidden md:block">
        <StepBoxes />
    </div>
    </>
  );
};

export default HeroSection;
